var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"container lg:px-10 max-w-7xl"},[_c('div',{staticClass:"py-4"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"object-contain object-left w-40 h-8",attrs:{"src":_vm.logo,"alt":"wealth-research","width":"160","height":"32"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }